import { render, staticRenderFns } from "./SetorList.vue?vue&type=template&id=00afa229"
import script from "./SetorList.vue?vue&type=script&lang=js"
export * from "./SetorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports